module.exports = __webpack_public_path__ + "static/img/44.76d85f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/44.png
// module id = vGaB
// module chunks = 0